import React from 'react';
import { StorageChange } from '../types';
import { Database, ArrowRight, Hash } from 'lucide-react';

interface StorageDiffProps {
  changes: StorageChange[];
}

export function StorageDiff({ changes }: StorageDiffProps) {
  return (
    <div className="h-full border-t border-[#262626] bg-[#0F0F0F] flex flex-col overflow-hidden">
      <div className="h-8 border-bottom border-[#262626] flex items-center px-4 gap-2 bg-[#141414] shrink-0">
        <Database className="w-3.5 h-3.5 text-emerald-500" />
        <h2 className="text-[10px] font-bold uppercase tracking-widest text-white">State Transitions</h2>
        <div className="ml-auto flex items-center gap-3">
          <span className="text-[9px] font-mono text-[#525252]">TOTAL: {changes.length}</span>
        </div>
      </div>

      <div className="flex-1 overflow-x-auto overflow-y-hidden flex items-stretch p-4 gap-4 custom-scrollbar">
        {changes.length > 0 ? (
          changes.map((change, i) => (
            <div 
              key={`${change.address}-${change.slot}-${i}`}
              className="min-w-[320px] bg-[#0A0A0A] border border-[#262626] rounded-lg p-3 flex flex-col gap-3 group hover:border-emerald-500/30 transition-colors"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-6 h-6 rounded bg-emerald-500/10 flex items-center justify-center">
                    <Hash className="w-3 h-3 text-emerald-500" />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-[9px] font-mono text-[#525252] leading-none mb-1">CONTRACT</span>
                    <span className="text-[10px] font-mono text-white leading-none">
                      {change.address.slice(0, 10)}...{change.address.slice(-8)}
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-1.5">
                <span className="text-[9px] font-mono text-[#404040]">SLOT: {change.slot}</span>
                <div className="grid grid-cols-[1fr,24px,1fr] items-center gap-2">
                  <div className="bg-[#1A1A1A] p-2 rounded border border-[#262626] flex flex-col gap-1">
                    <span className="text-[8px] font-mono text-[#525252] uppercase">Before</span>
                    <span className="text-[10px] font-mono text-[#A3A3A3] truncate">{change.before}</span>
                  </div>
                  <ArrowRight className="w-4 h-4 text-[#404040]" />
                  <div className="bg-emerald-500/5 p-2 rounded border border-emerald-500/20 flex flex-col gap-1">
                    <span className="text-[8px] font-mono text-emerald-500 uppercase">After</span>
                    <span className="text-[10px] font-mono text-white truncate">{change.after}</span>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="flex-1 flex items-center justify-center">
            <div className="text-center">
              <Database className="w-8 h-8 text-[#1A1A1A] mx-auto mb-2" />
              <p className="text-[#262626] font-mono text-[10px] uppercase tracking-widest">No state changes detected in this trace</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
